import { render } from "./UserPostView.vue?vue&type=template&id=1a0145dd&scoped=true"
import script from "./UserPostView.vue?vue&type=script&lang=js"
export * from "./UserPostView.vue?vue&type=script&lang=js"

import "./UserPostView.vue?vue&type=style&index=0&id=1a0145dd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a0145dd"]])

export default __exports__